import Phaser from 'phaser';
import { ensureRunning, goTo, SCENE_KEYS, type PlaceholderSceneData } from '@/engine/nav';

const COLOR_FONDO = 0x14141c;
const COLOR_BOTON = 0x2a2a38;
const COLOR_BOTON_HOVER = 0x38384a;

/**
 * Escena genérica que recibe el id/nombre de una zona sin escena propia
 * todavía. Los bloques siguientes irán sustituyendo cada zona por su
 * escena real (interior de la casa, campo de fútbol, el monte, el barrio);
 * hasta entonces, tocar una zona en el hub cae aquí.
 */
export class PlaceholderScene extends Phaser.Scene {
  private zona!: PlaceholderSceneData;

  constructor() {
    super(SCENE_KEYS.PLACEHOLDER);
  }

  init(data: PlaceholderSceneData): void {
    this.zona = data;
  }

  create(): void {
    const { width, height } = this.scale;
    this.cameras.main.setBackgroundColor(COLOR_FONDO);

    ensureRunning(this, SCENE_KEYS.HUD);
    this.scene.bringToTop(SCENE_KEYS.HUD);

    this.add
      .text(width / 2, height * 0.42, this.zona.zoneName, {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '34px',
        fontStyle: 'bold',
        color: '#ffffff',
        align: 'center',
        wordWrap: { width: width - 80 },
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height * 0.42 + 56, `zona: ${this.zona.zoneId}`, {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '18px',
        color: '#8a8a95',
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height * 0.42 + 100, 'Próximamente en un bloque siguiente', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '18px',
        color: '#8a8a95',
      })
      .setOrigin(0.5);

    this.crearBotonVolver(width / 2, height * 0.78);
  }

  private crearBotonVolver(x: number, y: number): void {
    const ancho = 280;
    const alto = 76;

    const boton = this.add.graphics();
    const dibujar = (color: number) => {
      boton.clear();
      boton.fillStyle(color, 1);
      boton.fillRoundedRect(-ancho / 2, -alto / 2, ancho, alto, 18);
    };
    dibujar(COLOR_BOTON);
    boton.setPosition(x, y);

    this.add
      .text(x, y, '← Volver al barrio', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '22px',
        color: '#ffffff',
      })
      .setOrigin(0.5);

    const zonaTactil = this.add.zone(x, y, ancho, alto).setInteractive({ useHandCursor: true });
    zonaTactil.on('pointerover', () => dibujar(COLOR_BOTON_HOVER));
    zonaTactil.on('pointerout', () => dibujar(COLOR_BOTON));
    zonaTactil.on('pointerdown', () => dibujar(COLOR_BOTON_HOVER));
    zonaTactil.on('pointerup', () => {
      goTo(this, SCENE_KEYS.HUB);
    });
  }
}
